module.exports = __webpack_public_path__ + "static/media/linus_lam.1163a48f.png";